import { yupResolver } from '@hookform/resolvers/yup';
import { CustomButton } from '@Modules/core/components';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { useForm } from 'react-hook-form';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ISDPDataTableRowFormMeta } from '@Modules/admin/integrationSettings/containers/forms/base/sensitiveDataParameters/sdpDataTableRowFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { TSensitiveDataParametersDataTableData } from '@Modules/admin/integrationSettings/containers/mixedHandlers/base/sensitiveDataParameters/SensitiveDataParametersDataTableMeta';

type Props = {
    meta: ISDPDataTableRowFormMeta,
    data: TSensitiveDataParametersDataTableData
} & TFormUIProps;

export default React.forwardRef(function SDPDataTableRowFormUI ({ onSubmit, isLoading, isSubmitting, meta, data }: Props, ref: any) {

    const submitBtnRef = React.useRef<HTMLButtonElement>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ defaultValues: data, resolver: yupResolver(meta.schema) });

    React.useImperativeHandle(ref, () => ({ submitBtnRef }));

    const handleOnSubmit: (React.FormEventHandler<HTMLDivElement> & React.FormEventHandler<HTMLFormElement>) | undefined = (e) => {
        console.log("======== on SDPDataTableRowForm Submit ========");        
        e.preventDefault();
        handleSubmit(onSubmit)(e);
        e.stopPropagation();
        console.log("==========");
    }

    return (
        <CC.Box as={'form'} onSubmit={handleOnSubmit}>
        
            <CC.SimpleGrid columns={{base: 1, md: 2}} spacing={10} my={10}>
                {displayCustomInputs<ISDPDataTableRowFormMeta>(meta, register, errors, isLoading)}
            </CC.SimpleGrid>

            <CC.Button type={'submit'} ref={submitBtnRef} style={{display: "none"}}>
                Enregistrer
            </CC.Button>
        </CC.Box>
    );
});
